/**
 * Visual configuration for each SSE event type streamed from the agent.
 * Minimal styling — just label and color for the type indicator.
 */
const EVENT_CONFIG = {
  tool_call: {
    color: '#60a5fa',
    label: 'call',
  },
  tool_result: {
    color: '#34d399',
    label: 'result',
  },
  verify_start: {
    color: '#a78bfa',
    label: 'verify',
  },
  verify_sample: {
    color: '#a78bfa',
    label: 'sample',
  },
  verify_complete: {
    color: '#a78bfa',
    label: 'verify',
  },
  complete: {
    color: '#10b981',
    label: 'summary',
  },
  error: {
    color: '#ef4444',
    label: 'error',
  },
  done: {
    color: '#475569',
    label: 'end',
  },
};

export default EVENT_CONFIG;
